import { TreeSvg }       from '../atoms/TreeSvg';
import { WorldAssetSvg } from '../atoms/WorldAssetSvg';
import { RockSvg }       from '../atoms/RockSvg';

/**
 * Terrain layer — trees, world-specific assets, and rocks.
 * Ponds are rendered separately in PondLayer (below the player).
 * All elements scroll with the background (position driven by game loop).
 * Props: trees, worldAssets, rocks, env (environment name)
 */
export function TerrainLayer({ trees, worldAssets, rocks, env }) {
  return (
    <>
      {/* Trees — decorative foliage, no collision */}
      {(trees ?? []).map(tree => {
        const tw = tree.size;
        const th = Math.round(tree.size * 1.4);
        return (
          <div
            key={tree.id}
            className="tree"
            style={{ transform: `translate3d(${tree.x}px,${tree.y}px,0)`, width: tw, height: th }}
          >
            <TreeSvg tw={tw} th={th} variant={env} />
          </div>
        );
      })}

      {/* World-specific decorative assets */}
      {(worldAssets ?? []).map(wa => (
        <div
          key={wa.id}
          className={`worldspecificasset worldspecificasset--env-${env}`}
          style={{ transform: `translate3d(${wa.x}px,${wa.y}px,0)`, width: wa.size, height: wa.size }}
        >
          <WorldAssetSvg size={wa.size} variant={env} />
        </div>
      ))}

      {/* Rocks — solid map obstacles */}
      {(rocks ?? []).map(rock => (
        <div
          key={rock.id}
          className={`rock rock--env-${env}`}
          style={{ transform: `translate3d(${rock.x}px,${rock.y}px,0)`, width: rock.size, height: rock.size }}
        >
          <RockSvg variant={env} />
        </div>
      ))}
    </>
  );
}
